import { reportSupervisionTypes } from "./types";
import { newDate } from "helpers/dateTools";

const { GET_REPORT_SUPERVISION, SET_REPORT_SUPERVISION_FILTERS, RESTORE_INITIAL } = reportSupervisionTypes;

const initialState = {
  ReportSupervision: [],
  startDate: newDate(),
  endDate: newDate(),
  station: null,
};

export const reportSupervisionReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_REPORT_SUPERVISION:
      return { ...state, ReportSupervision: payload };
    case SET_REPORT_SUPERVISION_FILTERS:
      return {
        ...state,
        [payload.key]: payload.value
      };
    case RESTORE_INITIAL:
      return initialState;
    default:
      return state;
  }
};
